import { IBenefits } from "@novel/shared/interfaces/Discounts";
import { NovelGallerySubReducer } from "@customer-gallery/redux/galleryTypedRedux";

export interface IDiscountReducerState {
    isLoading: boolean;
    totalCustomerDiscounts: IBenefits[];
}

const initialState: IDiscountReducerState = {
    isLoading: false,
    totalCustomerDiscounts: [],
};

export const discountsReducer: NovelGallerySubReducer<IDiscountReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_DISCOUNTS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_DISCOUNTS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_DISCOUNTS": {
            return {
                ...state,
                isLoading: false,
                totalCustomerDiscounts: action.payload.totalCustomerDiscounts,
            };
        }

        default: {
            return state;
        }
    }
};
